import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

const styles = () => ({
  root: {},
  content: {
    maxWidth: 1144,
    margin: '0 auto',
    padding: '0px 32px',
  },
  noPadding: {
    padding: 0,
    marginTop: '0 !important',
    maxWidth: 'none',
  },
})

const PageWrapper = ({
  classes,
  className,
  wrapperComponent: WrapperComponent,
  children,
  padding,
}) => (
  <WrapperComponent
    className={classNames(
      classes.root,
      className,
      !padding && classes.noPadding
    )}>
    <div className={classNames(classes.content, !padding && classes.noPadding)}>
      {children}
    </div>
  </WrapperComponent>
)

PageWrapper.defaultProps = {
  padding: true,
  wrapperComponent: 'section',
}

PageWrapper.propTypes = {
  padding: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  wrapperComponent: PropTypes.string,
}

export default withStyles(styles)(PageWrapper)



// WEBPACK FOOTER //
// ./src/templates/PageWrapper.js